<template>
  <el-container class="chat-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" :placeholder="$t('common.search')" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" :element-loading-text="$t('chat.receivingMsg')"
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <virtual-scroller class="scroll-box" :items="showConversations">
        <template v-slot="{ item }">
          <chat-item :conversation="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)"
            @info="onShowInfo(item)" @dnd="onDnd(item)" @top="onTop(item)" :active="item === activeConv"></chat-item>
        </template>
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box v-if="activeConv && !isSystem(activeConv)" :conversation="activeConv"></chat-box>
      <chat-system-box v-if="activeConv && isSystem(activeConv)" :conversation="activeConv"></chat-system-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside,
    VirtualScroller
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: []
    }
  },
  methods: {
    onActiveItem(conv) {
      this.chatStore.setActive(conv.key);
    },
    onDelItem(conv) {
      this.$confirm(this.$t('chat.deleteChat', { name: conv.showName }), this.$t('chat.deleteChatTitle'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        if (this.isPrivate(conv) || this.isGroup(conv)) {
          const data = { chatId: conv.targetId }
          const chatTypeText = this.isPrivate(conv) ? "private" : "group";
          await this.$http({
            url: `/message/${chatTypeText}/deleteChat`,
            method: 'delete',
            data: data
          });
        }
        await this.chatStore.remove(conv.key);
      });
    },
    onShowInfo(conv) {
      if (this.isPrivate(conv)) {
        this.$router.push("/home/friend?id=" + conv.targetId);
      } else if (this.isGroup(conv)) {
        if (!this.groupStore.isGroup(conv.targetId)) {
          this.$message.error(this.$t('chat.notInGroup'))
          return;
        }
        this.$router.push("/home/group?id=" + conv.targetId);
      }
    },
    onDnd(conv) {
      if (this.isPrivate(conv)) {
        this.setFriendDnd(conv, conv.targetId, !conv.isDnd)
      } else {
        this.setGroupDnd(conv, conv.targetId, !conv.isDnd)
      }
    },
    setFriendDnd(conv, friendId, isDnd) {
      const formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(conv.key, isDnd)
      })

    },
    setGroupDnd(conv, groupId, isDnd) {
      const formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(conv.key, isDnd)
      })

    },
    onTop(conv) {
      if (this.isPrivate(conv)) {
        this.setFriendTop(conv, conv.targetId, !conv.isTop)
      } else {
        this.setGroupTop(conv, conv.targetId, !conv.isTop)
      }
    },
    setFriendTop(conv, friendId, isTop) {
      const formData = {
        friendId: friendId,
        isTop: isTop
      }
      this.$http({
        url: '/friend/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop)
        this.chatStore.setTop(conv.key, isTop)
      })
    },
    setGroupTop(conv, groupId, isTop) {
      const formData = {
        groupId: groupId,
        isTop: isTop
      }
      this.$http({
        url: '/group/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop)
        this.chatStore.setTop(conv.key, isTop)
      })
    },
    isShow(conv) {
      return !this.searchText || conv.showName.includes(this.searchText)
    },
    isPrivate(conv) {
      return this.$enums.CONVERSATION_TYPE.PRIVATE == conv.type
    },
    isGroup(conv) {
      return this.$enums.CONVERSATION_TYPE.GROUP == conv.type
    },
    isSystem(conv) {
      return this.$enums.CONVERSATION_TYPE.SYSTEM == conv.type
    }
  },
  computed: {
    activeConv() {
      return this.chatStore.activeConversation;
    },
    loading() {
      return this.chatStore.loading;
    },
    showConversations() {
      return this.chatStore.conversations.filter(conv => this.isShow(conv));
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }
}
</style>
